import { RECAPTCHA_SUCCESS, RECAPTCHA_ERROR } from '../../actions/actionTypes';

const initialState = {
    verification: ""
};

const recaptchaReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECAPTCHA_SUCCESS:
            return Object.assign({}, state, {
                verification: action.verification
            });
        case RECAPTCHA_ERROR:
            return Object.assign({}, state, {
                verification: ""
            });
        default:
            return state;
    }
};

export default recaptchaReducer;
